import React from "react";

const EmailIcon: React.FC = (props): JSX.Element => {
	return (
		<svg className="w-6 h-6" fill="#FFFFFF" role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
			<title>Email icon</title>
			<path d="M20 4H4C2.897 4 2 4.897 2 6v12c0 1.103 0.897 2 2 2h16c1.103 0 2-0.897 2-2V6c0-1.103-0.897-2-2-2zm0 2v.511l-8 5.01-8-5.01V6h16zM4 20v-9.489l7.445 4.653a1 1 0 0 0 1.11 0L20 10.511V20H4z" />
		</svg>
	);
};

export default EmailIcon; 